import { observer } from "mobx-react-lite";
import React, {  SyntheticEvent, useState } from "react"
import { useEffect } from "react";
import { DropdownProps, Grid,    Header,    Label,   Table } from 'semantic-ui-react'
import { history } from "../..";
import agent from "../../app/api/agent";
import {  _PrizeTypeOptions } from "../../app/lib/CommonData";
import LoadingComponent from "../../app/lib/LoadingComponent";
import MyDropDown from "../../app/lib/MyDropDown";
import {  PatternHistory } from "../../app/models/IDayResult";
import { useStore } from "../../app/store/store";


export default observer(function PatternHistory(){
    const [data, setData] = useState<PatternHistory[]>([]);
    const [page, setPage] = useState(1);
    const [drawType, setDrawType] = useState("T");
    const [noOfDraw, setNoOfDraw] = useState(50);
    const [loading, setLoading] = useState(true);
    const {userStore} = useStore();

    if(!userStore.isLogged){
        history.push("/");
    }

    const noOfDrawOptions = [
        {
            key: '25',
            text: '25 Draws',
            value: 25
        },
          
        {
          key: '50',
          text: '50 Draws',
          value: 50
        },
        {
            key: '100',
            text: '100 Draws',
            value: 100
        },
        {
            key: '200',
            text: '200 Draws',
            value: 200
        },
    ]

    const noOfDrawChanged = (e: SyntheticEvent<any, Event>, option: DropdownProps) =>{
        setPage(1);
        setNoOfDraw(parseInt(option.value+""));
        setLoading(true);
    }

    const handleDropDownSelect = (e: SyntheticEvent<any, Event>, option: DropdownProps)=>{
         setPage(1);
         setDrawType(option.value + "");
         setLoading(true);
        
    }


    useEffect(()=>{

        agent.Draw4DResult.getPatternHistory(drawType, noOfDraw, page).then((response)=>{

            setData(response);
        }).finally(()=>{
            setLoading(false);
        });

        
    },[drawType, noOfDraw, page]);

    if (loading){
        return (<LoadingComponent></LoadingComponent>); 
    }
    return (
      <div style={{overflowX:"auto"}}>
            <Grid>
            <Grid.Column verticalAlign="middle" textAlign="left" mobile={8} tablet={5} computer={5}>
              <MyDropDown zIndex="20" onChange={handleDropDownSelect} placeholder="Select Prize Type" 
                toolTip="Select Prize Type"
                options={_PrizeTypeOptions} defaultValue = {drawType}>
              </MyDropDown>
            </Grid.Column>
            <Grid.Column verticalAlign="middle" mobile={8} tablet={5} computer={5}>
                <MyDropDown zIndex="20" onChange={noOfDrawChanged} placeholder="Select # of Draw" 
                toolTip="Select # Draws"
                options={noOfDrawOptions} defaultValue = {noOfDraw}>
                </MyDropDown>
            </Grid.Column>
            <Grid.Column verticalAlign="middle" textAlign="center" mobile={16} tablet={6} computer={6}>
                    Pattern History
            </Grid.Column>
            </Grid>

        <Table celled  sortable unstackable className="freeze-head-and-col">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="center">Draw Date</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">ABCD</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">AABC</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">AABB</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">AAAB</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">AAAA</Table.HeaderCell>
         
            </Table.Row>
        </Table.Header>

        <Table.Body>

          {data.map((x,i) => {
             if( i === 0 ){
                 var total = x.a1 + x.a2 + x.a3 + x.a4+ x.a5;
                 var a1 =( (x.a1 / total) * 100.0).toFixed(0) + ' %';
                 var a2 = ((x.a2 / total) * 100.0 ).toFixed(0) +' %';
                 var a3 = ((x.a3 / total) * 100.0).toFixed(0) + '%';
                 var a4 = ((x.a4 / total) * 100.0).toFixed(0) +' %';
                 var a5 = ((x.a5 / total) * 100.0).toFixed(0) + '%';
                
                 if (total === 0){
                    return <Header textAlign="center">No Result</Header>
                }

                return (
                    <Table.Row key={i}>
                        <Table.Cell  textAlign="right">{i === 0 ? "Hit/% Summary" : x.draw_Date}</Table.Cell>
                        <Table.Cell  textAlign="center">
                        <Label circular color="blue">{x.a5 > 0 ? x.a5 : 0 }</Label>
                        <Label >{a5}</Label></Table.Cell>
                        <Table.Cell  textAlign="center"><Label circular color="blue">{x.a4 > 0 ? x.a4 : 0 }</Label>
                        <Label >{a4}
                        </Label></Table.Cell>
                        <Table.Cell  textAlign="center"><Label circular color="blue">{x.a3 > 0 ? x.a3 : 0 }</Label>
                        <Label >{a3}
                        </Label></Table.Cell>
                        <Table.Cell  textAlign="center"><Label circular color="blue">{x.a2 > 0 ? x.a2 : 0 }</Label>
                        <Label >{a2}
                        </Label></Table.Cell>
                        <Table.Cell  textAlign="center"><Label circular color="blue">{x.a1 > 0 ? x.a1 : 0 }</Label>
                        <Label >{a1}
                        </Label></Table.Cell>

                    </Table.Row>
                );
             }
            
            return (
                    <Table.Row key={i}>
                        <Table.Cell  textAlign="right">{x.draw_Date}</Table.Cell>
                        <Table.Cell  textAlign="right">{x.a5 > 0 ? x.a5 : "" }</Table.Cell>
                        <Table.Cell  textAlign="right">{x.a4 > 0 ? x.a4 : ""}</Table.Cell>
                        <Table.Cell  textAlign="right">{x.a3 > 0 ? x.a3 : ""}</Table.Cell>
                        <Table.Cell  textAlign="right">{x.a2 > 0 ? x.a2 : ""}</Table.Cell>
                        <Table.Cell  textAlign="right">{x.a1 > 0 ? x.a1 : ""}</Table.Cell>
                    </Table.Row>
            );
          }  
          )} 
           </Table.Body>
      </Table>
      </div>
    );
});